module.exports = __webpack_public_path__ + "img/success.7f8345f7.svg";